import { render, staticRenderFns } from "./Tk.vue?vue&type=template&id=2c3d2839&"
import script from "./Tk.vue?vue&type=script&lang=js&"
export * from "./Tk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports